import { Button, SvgIcon } from '@volue/wave-react';
import type { ButtonProps } from '@volue/wave-react/dist/ts/components/Button';
import React from 'react';

import { useActions, useAppState } from '@/overmind';

export const SaveCalculationSetExecutionReport = (props: {
  className?: string;
  text: string;
  variant?: ButtonProps['variant'];
}) => {
  const isSavingCalculationSetExecutionReportEnabled =
    useAppState().featureToggles?.isSavingCalculationSetExecutionReportEnabled;
  const saveCalculationSetExecutionReport =
    useActions().calculation.saveCalculationSetExecutionReport;
  if (isSavingCalculationSetExecutionReportEnabled)
    return (
      <div
        data-testid="save-error-report-button"
        className={`dF fdC jcC ${props.className || ''}`}
      >
        <Button
          variant={props.variant}
          size="small"
          leftIcon={<SvgIcon iconName="save" />}
          onClick={() => saveCalculationSetExecutionReport()}
        >
          {props.text}
        </Button>
      </div>
    );
  return null;
};
